// Generated by CoffeeScript 1.12.2
require.config({
  baseUrl: '/javascript/libs',
  enforceDefine: false,
  waitSeconds: 120,
  paths: {
    collections: '../collections',
    etc: '../etc',
    models: '../models',
    views: '../views',
    templates: '../../templates',
    underscore: 'lodash',
    maskedInput: 'jquery.maskedinput',
    text: 'require_plugins/text',
    propertyParser: 'require_plugins/propertyParser'
  }
});

define('../main',['require','jquery','views/survey_view'],function(require) {
  var $, SurveyView;
  window.DEBUG = false;
  if (!window.console) {
    window.console = {
      log: function() {},
      error: function() {}
    };
  }
  $ = require('jquery');
  SurveyView = require("views/survey_view");
  return $(document).ready(function() {
    var surveyView;
    surveyView = new SurveyView();
    surveyView.on(SurveyView.UNAVAILABLE_EVENT, function() {
      return window.location.href = GLOBALS.uris.front + "/unavailable";
    });
    return surveyView.render(GLOBALS.data || location.pathname.slice(1));
  });
});

